import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  QUINTS_API_TOKEN_REFRESH_API_URL,
  QUINTS_API_TOKEN_REFRESH_MUTATION_KEY,
  QUINTS_API_URLS_PERMISSIONS,
  QUINTS_API_URLS_QUERY_KEY,
} from '@modules/quints-api/constants';
import { useToastStore } from '@modules/toast/store';

export default function useQuintsApiTokenMutation(): IContextMutationResult<void, Error, void> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, void>({
    mutationKey: [QUINTS_API_TOKEN_REFRESH_MUTATION_KEY],
    mutationFn: () => fetchPut<void>(
      QUINTS_API_TOKEN_REFRESH_API_URL,
      { },
      {
        permission: QUINTS_API_URLS_PERMISSIONS.EDIT,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [QUINTS_API_URLS_QUERY_KEY] });

      displayPresetToast('success');
    },
  });
}
